import React, { useMemo, useState } from "react";
import "./bundleOffer.css";

function BundleTargetPicker({
  label,
  options = [],
  selected = [],
  setSelected,
}) {
  const [search, setSearch] = useState("");

  const filteredOptions = useMemo(() => {
    const query = search.trim().toLowerCase();

    if (!query) return options;

    return options.filter((option) =>
      String(option.label || "")
        .toLowerCase()
        .includes(query)
    );
  }, [options, search]);

  const toggleItem = (id) => {
    const exists = selected.includes(id);

    if (exists) {
      setSelected(
        selected.filter((item) => item !== id)
      );
    } else {
      setSelected([...selected, id]);
    }
  };

  return (
    <div className="bundle-target-picker">

      <div className="bundle-picker-header">
        <span className="bundle-picker-label">
          {label}
        </span>

        <span className="bundle-picker-count">
          {selected.length} selected
        </span>
      </div>

      <input
        type="text"
        className="bundle-picker-search"
        placeholder={`Search ${label.toLowerCase()}`}
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      <div className="bundle-picker-list">
        {filteredOptions.length > 0 ? (
          filteredOptions.map((option) => {
            const checked =
              selected.includes(option.value);

            return (
              <label
                key={option.value}
                className={`bundle-picker-row ${
                  checked
                    ? "bundle-picker-row-selected"
                    : ""
                }`}
              >
                <input
                  type="checkbox"
                  checked={checked}
                  onChange={() =>
                    toggleItem(option.value)
                  }
                />

                <span className="bundle-picker-row-text">
                  {option.label}
                </span>
              </label>
            );
          })
        ) : (
          <div className="bundle-picker-empty">
            No matching items found.
          </div>
        )}
      </div>
    </div>
  );
}

export default BundleTargetPicker;